
import React from 'react';
import { UserMenu } from '../navigation/UserMenu';
import { Menu, X } from 'lucide-react';

interface MobileHeaderProps {
  isAuthenticated: boolean;
  isHost: boolean;
  onLogout: () => void;
  isMobileMenuOpen: boolean;
  toggleMobileMenu: () => void;
}

export const MobileHeader: React.FC<MobileHeaderProps> = ({
  isAuthenticated,
  isHost,
  onLogout,
  isMobileMenuOpen,
  toggleMobileMenu
}) => {
  return (
    <div className="md:hidden flex items-center">
      {isAuthenticated ? (
        <button 
          onClick={toggleMobileMenu} 
          className="p-2 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors touch-manipulation flex items-center gap-2"
          aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
        >
          {isMobileMenuOpen ? (
            <X className="h-5 w-5 text-gray-700" />
          ) : (
            <Menu className="h-5 w-5 text-gray-700" />
          )}
        </button>
      ) : (
        <UserMenu 
          isHost={isHost} 
          isAuthenticated={isAuthenticated} 
          onLogout={onLogout} 
        />
      )}
    </div>
  );
};
